module.exports = __webpack_public_path__ + "img/slider-2.10bf0171.png";